import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';

import { HEIGHT_HEADER_ROW } from '../../const';
import { getDateScaled } from '../../functions';
import { RootState } from '../../store';
import { CalendarScaleType, DraggableGantType, HeaderType, ModeTimeLineType } from '../../types';
import { useGantOperationalHeight } from '../hook/useGantOperationalHeight';

export const useGantGridDatePeriodMetrics = (typeGrid: 'header' | 'main') => {
    const dragging = useSelector<RootState, DraggableGantType>((state) => state.gantDraggable.dragging);
    const currentDate = useSelector<RootState, string>((state) => state.calendar.currentDate);
    const scheduleScale = useSelector<RootState, CalendarScaleType>((state) => state.calendar.scheduleScale);
    const widthColumn = useSelector<RootState, number>((state) => state.gant.widthColumn);
    const startDateExtend = useSelector<RootState, string>((state) => state.gant.startDateExtend);
    const dragX = useSelector<RootState, number>((state) => state.gantDraggable.currentPeriodPositionX);
    const modeTimeLine = useSelector<RootState, ModeTimeLineType>((state) => state.gant.modeTimeLine);
    const headerType = useSelector<RootState, HeaderType>((state) => state.gant.headerType);

    const visibleHeight = useGantOperationalHeight();

    const currentDateScaled = getDateScaled(currentDate, scheduleScale);

    const isDragging = dragging === 'calendarDate';

    const offsetDays = currentDateScaled.isValid
        ? currentDateScaled.diff(DateTime.fromSQL(startDateExtend), 'days').days
        : 0;

    const columns = scheduleScale === 'day' ? 1 : 7;
    const width = widthColumn * columns;
    const x1 = isDragging ? dragX : offsetDays * widthColumn;
    const x2 = x1 + width;

    const height = typeGrid === 'main' ? visibleHeight : HEIGHT_HEADER_ROW;

    const isComponentVisible = modeTimeLine !== 'pagination' || headerType !== 'week' || headerType !== scheduleScale;

    return {
        isDragging,
        x1,
        x2,
        width,
        height,
        widthColumn,
        dragX,
        scheduleScale,
        isComponentVisible,
    };
};
